/**
 * @name                                    main.ts
 * @description                             the entry point.
 * @author                                  Maysara Elshewehy
 * @repo                                    https://github.com/je-es/cli
 *
 * @note                                    This script follows the `MECS` code style
*/



/* ┌─────────────────────────────────────── PACK ───────────────────────────────────────┐  */

    export *                                from './mod/types.d';
    export *                                from './mod/cli';

/* └────────────────────────────────────────────────────────────────────────────────────┘  */